import React, { useState, useContext } from "react";
import moment from "moment";
import gql from "graphql-tag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApolloClient } from "react-apollo";
import { Control, Label, Input, Title, Button, Icon } from "rbx";
import { ourToast as toast } from "../../../utils";
import Loading from "../../../components/Loading";
import { ModalContext } from "../../../components/ModalProvider";
import { Confirmation } from "../../../components/modals";
import { MOVE_ORDER_ARCHIVE_MUTATION } from "../../../graphql/OrderArchives/OrderArchives.graphql";

const today = new Date();
const INITIAL_STATE = {
  ArchiveDate: new Date(moment(`12/31/${today.getFullYear() - 3} 23:59:59`))
};

const ALL_ORDERS_VIEW_QUERY = gql`
  query VW_Orders($where: VW_OrderWhereInput!) {
    VW_Orders(where: $where) {
      RecId
    }
  }
`;

const OrderArchiveHistoryPage = () => {
  const client = useApolloClient();
  const [state, setState] = useState(INITIAL_STATE);
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setModalOpen } = useContext(ModalContext);

  const onChange = async e => {
    if (moment(e.target.value) > moment(INITIAL_STATE.ArchiveDate)) {
      toast.error(
        `The date selected must be prior than ${moment(
          INITIAL_STATE.ArchiveDate
        ).format("MM/DD/YYYY")}`
      );
    } else {
      const { value } = e.target;
      const updates = { ...state };
      updates[e.target.name] = value;
      setState({ ...updates });
      setLoading(true);
      const { data } = await client.query({
        query: ALL_ORDERS_VIEW_QUERY,
        variables: {
          where: {
            OrderDate_lt: moment(value)
              .startOf("day")
              .toISOString()
          }
        },
        fetchPolicy: "network-only"
      });
      setOrders(data.VW_Orders);
      setLoading(false);
    }
  };

  const onArchiveClick = () => {
    if (orders?.length > 0) {
      const performArchive = async () => {
        try {
          setModalOpen(false);
          setLoading(true);
          const { data } = await client.mutate({
            mutation: MOVE_ORDER_ARCHIVE_MUTATION,
            variables: {
              orders: orders.map(o => o.RecId)
            },
            refetchQueries: ["ALL_ORDERS_VIEW_QUERY"]
          });
          setLoading(false);
          if (!data.moveToOrderArchive) {
            throw new Error("Error moving Orders to Archive.");
          }
          toast.success("Orders archived successfully.");
          setOrders([]);
        } catch (err) {
          toast.error("Error archiving Orders.");
        }
      };
      setModalOpen(
        true,
        <Confirmation
          message={`Are you sure you want to Archive Orders through ${moment(
            state.ArchiveDate
          ).format("MM/DD/YYYY")}?`}
          onConfirm={performArchive}
        />
      );
    } else {
      toast.error("There's no orders selected to archive");
    }
  };

  return (
    <React.Fragment>
      <Control style={{ width: "30%" }}>
        <Label>Archive Date Through</Label>
        <Input
          name="ArchiveDate"
          type="date"
          value={
            state.ArchiveDate
              ? moment(state.ArchiveDate).format("YYYY-MM-DD")
              : ""
          }
          onChange={onChange}
        />
      </Control>
      {loading && <Loading />}
      {orders && !loading && (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Title>{orders.length} Orders to archive</Title>
          <Button color="primary" onClick={onArchiveClick}>
            <Icon>
              <FontAwesomeIcon icon="sync" />
            </Icon>
            <span>Archive</span>
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

OrderArchiveHistoryPage.propTypes = {};
export default OrderArchiveHistoryPage;
